import React from 'react';
import { fmtRange } from './agendaUtils';

export const AgendaEventContent = ({ event, view }) => {
  const p = event.extendedProps;
  if (p._kind === 'preview') {
    return (
      <div className="w-full h-full px-1.5 py-0.5 text-[11px] font-bold leading-tight" data-testid={`agenda-preview-${p.id}`}>
        {p.ok ? 'Aperçu' : 'Conflit'} · {fmtRange(p.time, p.end_time)}
      </div>
    );
  }
  const isTask = p._kind === 'task';
  const internal = p.category === 'interne';
  const range = event.allDay ? 'Plusieurs jours' : fmtRange(p._seg_start || p.time, p._seg_end || p.end_time);
  const work = isTask ? p.title : [p.intervention_type || p.description || '', internal && (p.precisions || []).join(', ')].filter(Boolean).join(' — ');
  const sub = isTask ? (p.assignee || 'Équipe atelier') : internal ? (p.assigned_employee_name || 'Équipe atelier') : (p.vehicle_info || '');
  const name = isTask ? 'Atelier' : internal ? 'Travaux internes' : (p.client_name || 'Client');
  const compact = view.type === 'dayGridMonth';
  const mins = event.end && event.start ? (event.end - event.start) / 60000 : 30;
  if (!compact && !event.allDay && mins <= 45) {
    return (
      <div className="w-full h-full overflow-hidden px-1.5 py-0.5 text-[11px] leading-tight" data-testid={`agenda-event-${p.id}${p._seg_start ? `-${p._seg_start}` : ''}`}>
        <span className="font-bold">{range}</span> · <span className="font-semibold">{name}</span>{work && ` · ${work}`}
      </div>
    );
  }
  return (
    <div className={`w-full h-full overflow-hidden leading-tight ${compact ? 'px-1 py-0.5' : 'p-1.5'}`} data-testid={`agenda-event-${p.id}${p._seg_start ? `-${p._seg_start}` : ''}`}>
      <div className="text-[11px] font-bold tracking-wide opacity-95">{range}</div>
      <div className={`font-semibold truncate ${compact ? 'text-xs' : 'text-sm'}`}>{name}</div>
      {sub && <div className="text-[11px] opacity-80 truncate">{sub}</div>}
      {work && <div className={`text-[11px] font-medium truncate ${compact ? '' : 'mt-0.5'}`}>{work}</div>}
    </div>
  );
};
